import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useLazyGetFactoriesQuery } from '@/api/queries/factory';
import { useLazyGetUserQuarriesForClaimQuery } from '@/api/queries/quarry';
import { useLazyGetWorkshopQuery } from '@/api/queries/workshop';
import { buyCryptoBoostsFactory } from '@/redux/reducers/factoryReducer';
import { buyCryptoBoostsQuarry } from '@/redux/reducers/quarryReducer';
import { buyCryptoBoostsWorkshop } from '@/redux/reducers/workshopReducer';
import { type RootState, useAppDispatch, useAppSelector } from '@/redux/store';

import { type BoostItemType } from '../types/factoryType';

const useBuyBoostForCrypto = (): ((data: BoostItemType[]) => void) => {
  const quarries = useAppSelector(
    (state) => state.quarry.quarries?.userQuarries,
  );
  const factories = useSelector((state: RootState) => state.factory?.list);
  const workshops = useSelector((state: RootState) => state.workshop?.list);
  const [fetchQuarry] = useLazyGetUserQuarriesForClaimQuery();
  const [fetchFactory] = useLazyGetFactoriesQuery();
  const [fetchWorkshop] = useLazyGetWorkshopQuery();
  const dispatch = useAppDispatch();

  const addBoost = useCallback(
    (data: BoostItemType[]): void => {
      for (const q of quarries || []) {
        if (q.id === data[0].plants[0]) {
          console.log('boost for quarries');
          dispatch(buyCryptoBoostsQuarry(data));
          // Інвалідуємо кеш для оновлення даних кар'єрів
          fetchQuarry(undefined);

          return;
        }
      }
      for (const f of factories || []) {
        if (f.id === data[0].plants[0]) {
          console.log('boost for factories');
          dispatch(buyCryptoBoostsFactory(data));
          // Інвалідуємо кеш для оновлення даних фабрик
          fetchFactory(undefined);

          return;
        }
      }
      for (const w of workshops || []) {
        if (w.id === data[0].plants[0]) {
          console.log('boost for workshops');
          dispatch(buyCryptoBoostsWorkshop(data));
          // Інвалідуємо кеш для оновлення даних майстерень
          fetchWorkshop();

          return;
        }
      }
    },
    [quarries, factories, workshops],
  );

  return addBoost;
};

export { useBuyBoostForCrypto };
